module.exports = __webpack_public_path__ + "assets/22c67422ea77ef951a071243728409de.mp3";